<div class="help-desk-block">
  <p>{{ 'HELP_DESK.INFO' | transloco }}</p>
  <span class="d-flex align-items-center">
    <a href="mailto:{{ email }}"><img src="assets/icons/help_desk.svg" alt="Help desk"/></a>
    <p style="color: #BBBBBB;">{{ 'HELP_DESK.CONTACT_BY_EMAIL' | transloco }}</p>
  </span>
</div>
